import { __awaiter } from '../_virtual/_tslib.js';
import { getDeviceInfo } from '../methods/getDeviceInfo.js';
import API from './const.js';
import { saveAuthToken } from './utils/saveAuthToken.js';
import { getAuthHeader } from './utils/getAuthHeader.js';
import { removeAuthToken } from './utils/removeAuthToken.js';
import { toast } from '../components/toast/toast.js';
import { ga4sendEvent } from './user-analytics.service.js';
import { validateAndConvertReqParamToInt } from './utils/validateAndConvertReqParamToNum.js';
import { getNullApiResponse } from './utils/get-null-api-response.js';
import { Cookies } from 'react-cookie';
import { COOKIES } from '../constants/misc.js';

var LoginMode;
(function (LoginMode) {
    LoginMode[LoginMode["PASSWORD"] = 1] = "PASSWORD";
    LoginMode[LoginMode["OTP"] = 2] = "OTP";
    LoginMode[LoginMode["SSO"] = 3] = "SSO";
})(LoginMode || (LoginMode = {}));
function registerCompanyDetails({ userId, name, serviceType, placeId, referralCode, sessionId, user_joining_bonus_enabled }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(API.REGISTER_COMPANY_DETAILS, {
                method: "POST",
                headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader()),
                body: JSON.stringify({
                    user_id: parseInt(userId),
                    name,
                    service_type: serviceType,
                    place_id: placeId,
                    referral_code: referralCode,
                    session_id: sessionId,
                    user_joining_bonus_enabled: true
                })
            }));
            if (call.status === 200) {
                const response = yield call.json();
                saveAuthToken(response.data.access_token);
                return response.data;
            }
        }
        catch (error) {
            toast.error("An error occured, please try again after sometime");
        }
        return null;
    });
}
const ErrorMap = {
    "User does not exist": "userNotFound",
    "Password is incorrect": "incorrectPassword"
};
function loginViaOtp({ phone_number, otp, is_wa_optin }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { browser, os, platform } = getDeviceInfo();
            const rqst = new Request(API.LOGIN_VIA_OTP, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    // key: process.env.REACT_APP_KEY || ""
                },
                body: JSON.stringify({
                    phone_number: String(phone_number),
                    otp: validateAndConvertReqParamToInt("otp", otp),
                    mode: LoginMode.OTP,
                    is_wa_optin: is_wa_optin || false,
                    device_information: JSON.stringify({
                        model: platform.model,
                        brand: platform.vendor,
                        type: platform.type,
                        os_name: os.name,
                        os_version: os.version,
                        browser: browser.name,
                        browser_version: browser.version
                    })
                })
            });
            const call = yield fetch(rqst);
            if (call.status === 200) {
                const { data } = yield call.json();
                saveAuthToken(data.access_token);
                return { data };
            }
            if (!call.ok) {
                const response = yield call.json();
                toast.error(response.message);
                throw yield call.json();
            }
        }
        catch (e) {
            // @ts-ignore aa
            return { data: null, code: ErrorMap[e.title] };
        }
        return { data: null };
    });
}
function sessionLogout(phone_number) {
    return __awaiter(this, void 0, void 0, function* () {
        const validatedPhoneNumber = validateAndConvertReqParamToInt("phone_number", phone_number);
        const cookies = new Cookies();
        const token = cookies.get(COOKIES.token);
        if (!validatedPhoneNumber || !token) {
            return getNullApiResponse();
        }
        try {
            const rqst = new Request(API.LOGOUT, {
                method: "POST",
                headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader()),
                body: JSON.stringify({
                    phone_number: String(validatedPhoneNumber)
                })
            });
            const call = yield fetch(rqst);
            if (!call.ok) {
                const response = yield call.json();
                toast.error(response.message);
                throw response;
            }
        }
        catch ({ data, message }) {
            return { data: null, message };
        }
        return { data: null };
    });
}
const logout = (phoneNum) => {
    ga4sendEvent("Signup_logout_web", { value: 1 });
    sessionLogout(phoneNum).finally(removeAuthToken);
};
const userAllDevicelogout = (phoneNum) => __awaiter(void 0, void 0, void 0, function* () {
    return sessionLogout(phoneNum).then(({ message }) => {
        !message && toast.success("User logged out successfully from all the devices");
    });
});
const AuthService = {
    registerCompanyDetails,
    loginViaOtp,
    logout,
    userAllDevicelogout
};

export { AuthService, logout, userAllDevicelogout };
//# sourceMappingURL=auth.service.js.map
